import { LocalStorageStore } from '@wyz/utils';
import * as React from 'react';
import { useAuth } from 'react-oidc-context';
import { useConfig } from '~/common/context';
import { log } from '~/common/helpers';
import { SESSION_LS_KEYS } from '~/purchase/helpers';

export const useLogout = () => {
  const auth = useAuth();
  const config = useConfig();

  return React.useCallback(
    (postLogoutRedirectUri: string = config.baseAppUrl) => {
      Object.values(SESSION_LS_KEYS).forEach((key) =>
        LocalStorageStore.remove(key),
      );
      auth
        .signoutRedirect({
          post_logout_redirect_uri: postLogoutRedirectUri,
        })
        .catch((error: Error) => {
          log(error);
        });
    },
    [auth, config.baseAppUrl],
  );
};
